// Session storage keys
export const ACCESS_TOKEN = 'accessToken';
export const PREVIOUS_PATH = 'prevPath';

// Local storage keys
export const AVAILABILITY_SETTINGS = 'availabilitySettings';
export const PWA_INSTALL_POPUP_IOS = 'pwaInstallPopupIOS';
